import { Hidden } from "@mui/material";
import CartIcon from "./CartIcon";
import CompareIcon from "./ComparIcon";
import ProfileIcon from "./ProfileIcon";
import SearchIcon from "./SearchIcon";
import WishListIcon from "./WishListIcon";

export default function ActionIcons() {

  return (
    <div className="flex gap-4  items-center pl-2">
      <Hidden mdUp>
        <SearchIcon />
      </Hidden>
      <ProfileIcon />
      <CartIcon />
      {/* <Hidden mdDown>
        <WishListIcon />
        <CompareIcon />
      </Hidden> */}

    </div>
  )
}